import { Schema, schema } from 'normalizr';

import { ReferenceTypeSchemaMapping, TeamsMeetingOverrides, processTeamsMeeting } from '../strategies/teamsMeeting';

import { officeGroupSchema } from './officeGroupSchema';
import { userSchema } from './user';

const inviteeUnionDefinition: Record<ReferenceTypeSchemaMapping[keyof ReferenceTypeSchemaMapping], Schema> = {
  officeGroups: officeGroupSchema,
  users: userSchema,
};

const teamsMeetingInviteeSchema = new schema.Union(inviteeUnionDefinition, '__typename');

const teamsMeetingSchemaDefinition: Record<keyof TeamsMeetingOverrides, Schema> = {
  organizers: [userSchema],
  moderators: [userSchema],
  invitees: [teamsMeetingInviteeSchema],
};

export const teamsMeetingSchema = new schema.Entity('teamsMeetings', teamsMeetingSchemaDefinition, {
  processStrategy: processTeamsMeeting,
});
